var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import _cloneDeep from "lodash/cloneDeep";
import _defaultsDeep from "lodash/defaultsDeep";
import { ConsentEntityValidator, StorageName } from "../../../constants/sdk";
import LoggingModule from "../../logging-module";
const DATA_TEMPLATE = {
  data: {},
  timestamp: 0
};
class BaseStorageWrapper {
  constructor(name = "BaseStorageWrapper", shouldClone = false) {
    this.insertDataByStorageName = (store, storageName, data, timestamp) => {
      LoggingModule.info(`[${this.name}]: insertDataByStorageName`, {
        data,
        storageName,
        timestamp
      });
      const { data: prevData = {}, timestamp: prevTimestamp = 0 } = store[storageName];
      if (prevTimestamp < timestamp) {
        const newData = _defaultsDeep({}, data, prevData);
        store[storageName] = { data: newData, timestamp };
      }
    };
    this.getConsentData = (userInfo, keys) => {
      LoggingModule.info(`[${this.name}]: getConsentData`, {
        userInfo,
        keys
      });
      const data = {};
      const { user_id: userId = "" } = userInfo != null ? userInfo : {};
      const store = this.getConsentStore(userInfo);
      const entityKeys = (keys == null ? void 0 : keys.length) ? keys : Object.keys(store.consentEntityValidationMap);
      entityKeys.forEach((key) => {
        var _a, _b, _c, _d;
        const validator = store.consentEntityValidationMap[key];
        switch (validator) {
          case ConsentEntityValidator.BOTH: {
            data[key] = store[StorageName.BOTH_CONSENT].data[key];
            break;
          }
          case ConsentEntityValidator.DEVICE_ID: {
            data[key] = store[StorageName.DEVICE_CONSENT].data[key];
            break;
          }
          case ConsentEntityValidator.USER_ID: {
            data[key] = store[StorageName.USER_CONSENT].data[key];
            break;
          }
          case ConsentEntityValidator.ANY: {
            const userIdRelatedEntity = store[StorageName.USER_CONSENT].data[key];
            const deviceIdRelatedEntity = store[StorageName.DEVICE_CONSENT].data[key];
            const userIdRecordTime = (_b = (_a = userIdRelatedEntity == null ? void 0 : userIdRelatedEntity.record) == null ? void 0 : _a.created_at) != null ? _b : 0;
            const deviceIdRecordTime = (_d = (_c = deviceIdRelatedEntity == null ? void 0 : deviceIdRelatedEntity.record) == null ? void 0 : _c.created_at) != null ? _d : 0;
            if (userId && userIdRecordTime >= deviceIdRecordTime) {
              data[key] = userIdRelatedEntity;
            } else {
              data[key] = deviceIdRelatedEntity;
            }
            break;
          }
          default: {
            break;
          }
        }
      });
      return data;
    };
    this.getNotificationData = (userInfo) => {
      LoggingModule.info(`[${this.name}]: getNotificationData`, {
        userInfo
      });
      const store = this.getNotificationStore(userInfo);
      return store.notification.data;
    };
    this.splitConsentEntityData = (data, userInfo) => {
      LoggingModule.info(`[${this.name}]: splitConsentEntityData`, {
        userInfo,
        data
      });
      const deviceConsentData = {};
      const userConsentData = {};
      const bothRequiredConsentData = {};
      const consentEntityValidationMap = {};
      const { device_id: deviceId = "", user_id: userId = "" } = userInfo != null ? userInfo : {};
      if (data) {
        Object.keys(data).forEach((key) => {
          const entity = data[key];
          if (entity) {
            consentEntityValidationMap[key] = entity.validator;
            switch (entity.validator) {
              case ConsentEntityValidator.ANY: {
                if (deviceId) {
                  deviceConsentData[key] = entity;
                }
                if (userId) {
                  userConsentData[key] = entity;
                }
                break;
              }
              case ConsentEntityValidator.DEVICE_ID: {
                if (deviceId) {
                  deviceConsentData[key] = entity;
                }
                break;
              }
              case ConsentEntityValidator.USER_ID: {
                if (userId) {
                  userConsentData[key] = entity;
                }
                break;
              }
              case ConsentEntityValidator.BOTH: {
                if (userId && deviceId) {
                  bothRequiredConsentData[key] = entity;
                }
                break;
              }
              default: {
                break;
              }
            }
          }
        });
      }
      return {
        deviceConsentData,
        userConsentData,
        bothRequiredConsentData,
        consentEntityValidationMap
      };
    };
    this.insertDataIntoStore = (data, timestamp, userInfo) => {
      LoggingModule.info(`[${this.name}]: insertDataIntoStore`, {
        userInfo,
        data,
        timestamp
      });
      const store = this.getConsentStore(userInfo);
      const { deviceConsentData, userConsentData, bothRequiredConsentData, consentEntityValidationMap } = this.splitConsentEntityData(data, userInfo);
      this.insertDataByStorageName(store, StorageName.DEVICE_CONSENT, deviceConsentData, timestamp);
      this.insertDataByStorageName(store, StorageName.USER_CONSENT, userConsentData, timestamp);
      this.insertDataByStorageName(store, StorageName.BOTH_CONSENT, bothRequiredConsentData, timestamp);
      store.consentEntityValidationMap = _defaultsDeep({}, consentEntityValidationMap, store.consentEntityValidationMap);
      return store;
    };
    this._formatConsentRecord = (entity) => {
      const { key, type, name, category, validator, record } = entity != null ? entity : {};
      if (record && type && name && category && validator && key) {
        const consentRecord = __spreadProps(__spreadValues({}, record), {
          entity_key: key,
          entity_type: type,
          entity_name: name,
          entity_category: category,
          entity_validator: validator
        });
        return consentRecord;
      } else {
        return null;
      }
    };
    this.getRecord = (key, userInfo) => {
      LoggingModule.info(`[${this.name}]: getRecord`, {
        userInfo,
        key
      });
      const data = this.getConsentData(userInfo, [key]);
      const consentRecord = this._formatConsentRecord(data == null ? void 0 : data[key]);
      if (consentRecord) {
        return this.shouldClone ? _cloneDeep(consentRecord) : consentRecord;
      } else {
        LoggingModule.info(`[${this.name}]: getRecord - no record for ${key}`, {
          key
        });
        return null;
      }
    };
    this.getEntity = (key, userInfo) => {
      var _a;
      LoggingModule.info(`[${this.name}]: getEntity`, {
        userInfo,
        key
      });
      const data = this.getConsentData(userInfo, [key]);
      const consentEntity = (_a = data == null ? void 0 : data[key]) != null ? _a : null;
      if (!consentEntity) {
        LoggingModule.info(`[${this.name}]: getEntity - no entity for ${key}`, {
          key
        });
      }
      if (this.shouldClone) {
        return _cloneDeep(consentEntity);
      }
      return consentEntity;
    };
    this.getEntities = (keys, userInfo) => {
      var _a;
      LoggingModule.info(`[${this.name}]: getEntities`, {
        userInfo,
        keys
      });
      const entities = [];
      const data = (_a = this.getConsentData(userInfo, keys)) != null ? _a : {};
      if (keys == null ? void 0 : keys.length) {
        const missingKeys = [];
        keys.forEach((key) => {
          var _a2;
          const consentEntity = (_a2 = data == null ? void 0 : data[key]) != null ? _a2 : null;
          if (consentEntity) {
            entities.push(this.shouldClone ? _cloneDeep(consentEntity) : consentEntity);
          } else {
            missingKeys.push(key);
          }
        });
        if (missingKeys.length) {
          LoggingModule.info(`[${this.name}]: getEntities - missing some entities`, {
            entityKeys: missingKeys
          });
        }
      } else {
        Object.keys(data != null ? data : {}).forEach((key) => {
          var _a2;
          const consentEntity = (_a2 = data == null ? void 0 : data[key]) != null ? _a2 : null;
          if (consentEntity) {
            entities.push(this.shouldClone ? _cloneDeep(consentEntity) : consentEntity);
          }
        });
      }
      return entities;
    };
    this.getRecords = (keys, userInfo) => {
      LoggingModule.info(`[${this.name}]: getRecords`, {
        userInfo,
        keys
      });
      const records = [];
      const data = this.getConsentData(userInfo, keys);
      if (keys == null ? void 0 : keys.length) {
        const missingKeys = [];
        keys.forEach((key) => {
          const consentRecord = this._formatConsentRecord(data == null ? void 0 : data[key]);
          if (consentRecord) {
            records.push(this.shouldClone ? _cloneDeep(consentRecord) : consentRecord);
          } else {
            missingKeys.push(key);
          }
        });
        if (missingKeys.length) {
          LoggingModule.info(`[${this.name}]: getRecords - missing some records`, {
            entityKeys: missingKeys
          });
        }
      } else {
        Object.keys(data != null ? data : {}).forEach((key) => {
          const consentRecord = this._formatConsentRecord(data == null ? void 0 : data[key]);
          if (consentRecord) {
            records.push(this.shouldClone ? _cloneDeep(consentRecord) : consentRecord);
          }
        });
      }
      return records;
    };
    this.clean = () => {
      this.cleanConsentData();
      this.cleanNotificationData();
    };
    this.destruct = () => {
      this.clean();
    };
    this.name = name;
    this.shouldClone = shouldClone;
  }
}
var BaseStorageWrapper_default = BaseStorageWrapper;
export {
  DATA_TEMPLATE,
  BaseStorageWrapper_default as default
};
